module.exports = __webpack_public_path__ + "static/img/frack2.d48cd311.png";